import { Injectable } from '@angular/core';
import { GenericService } from '../generic.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private apiService:GenericService) { }

  getGenericRA(type:any, model:any){
    return this.apiService.Post<any>(`notification/get-generic-riskAssessment?type=${type}`, model);
  }

  getSpecificRA(type:any, model:any){
    return this.apiService.Post<any>(`notification/get-specificed-riskAssessment?type=${type}`, model);
  }

  getPendingRA(model:any){
    return this.apiService.Post<any>(`notification/get-approved-pending-riskAssessment`, model);
  }

  getNotifications(){
    return this.apiService.Get<any>(`notification/get-list`);
  }

  getCreatedAssessments(model:any){
    return this.apiService.Post<any>(`notification/get-created-assessment`, model);
  }
  getAssessmentsPerformed(model:any){
    return this.apiService.Post<any>(`notification/get-assessment-perform`, model);
  }
  getQuestionsCreated(model:any){
    return this.apiService.Post<any>(`notification/get-createdQuestion`, model);
  }
  getPassFail(model:any){
    return this.apiService.Post<any>(`notification/get-passandfail`, model);
  }

  getNotPerformed(model:any){
    return this.apiService.Post<any>(`notification/get-notPerformAssessment`, model);
  }

  getModule(){
    return this.apiService.Get<any>(`notification/NotificationPermissionDropdown`);
  }

  notifiactionPagination(model:any){
    return this.apiService.Post<any>(`notification/notification-action/pagination`,model);
  }

  getModulePermission(companyId:any){
    return this.apiService.Get<any>(`notification-module/permissions/${companyId}`);
  }

  notificationSetPermission(model:any){
    return this.apiService.Post<any>(`notification-module/set-permission`,model);
  }
}
